import { useEffect } from "react";
import { baseName } from "../../const";

const usePageTitle = (title, flag) => {
    useEffect(() => {
        // Set the document title when the component mounts
        document.title = `${title} ${flag ? `| ${baseName}` : ""} `;

        // Optionally, reset to a default title or previous title when the component unmounts
        return () => {
            // You can set a default title here or leave it as is
            document.title = "Coins Baskets";
        };
    }, [title]); // Dependency array includes `title` so it updates if `title` changes
};

export default usePageTitle;
